import { render, staticRenderFns } from "./dialogSubmit.vue?vue&type=template&id=777cd805&scoped=true&"
import script from "./dialogSubmit.vue?vue&type=script&lang=js&"
export * from "./dialogSubmit.vue?vue&type=script&lang=js&"
import style0 from "./dialogSubmit.vue?vue&type=style&index=0&id=777cd805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777cd805",
  null
  
)

export default component.exports